/* Design tab — extracted from FormBuilder.jsx (A7a) */
import React from 'react';
import { LAYOUT_OPTIONS } from '../../utils/formTemplates';
import FormRenderer from '../FormRenderer';

export default function DesignTab({
  isMobile,
  layout,
  setLayout,
  layoutConfig,
  setLayoutConfig,
  theme,
  setTheme,
  designSettings,
  setDesignSettings,
  formName,
  fields,
  rows,
  previewData,
  setPreviewData,
  showToast,
}) {
  return (
          <div className={`fb-grid-design${isMobile ? ' is-mobile' : ''}`}>
            {/* Theme Controls */}
            <div className={`fb-card${isMobile ? ' is-mobile' : ''}`}>
              <h3 className="fb-subsection-title">Theme Customization</h3>
              <p className="fb-muted" style={{ marginBottom: '2rem' }}>
                Customize the appearance of your form. Changes apply to the embedded form.
              </p>
              
              {/* Layout Selector */}
              <div className="fb-divider-section">
                <label className="fb-label-lg">
                  Form Layout
                </label>
                <p className="fb-muted" style={{ fontSize: '0.85rem', marginBottom: '1rem' }}>
                  Choose how your form is displayed to users.
                </p>
                <div className="fb-grid-auto-fill">
                  {LAYOUT_OPTIONS.map(layoutOption => (
                    <button
                      key={layoutOption.id}
                      type="button"
                      className="fb-layout-btn"
                      onClick={() => {
                        setLayout(layoutOption.id);
                        setLayoutConfig(layoutOption);
                      }}
                      style={{
                        border: layout === layoutOption.id ? `2px solid ${theme.primaryColor}` : '2px solid var(--hairline-5)',
                        background: layout === layoutOption.id ? `${theme.primaryColor}15` : 'var(--surface)',
                      }}
                    >
                      <div className={`fb-layout-btn-name${layout === layoutOption.id ? ' selected' : ''}`}>
                        {layoutOption.name}
                      </div>
                      <div className="fb-muted" style={{ fontSize: '0.75rem', marginTop: '0.35rem', lineHeight: 1.3 }}>
                        {layoutOption.description}
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Field direction & scroller */}
              <div className="fb-divider-section">
                <label className="fb-label-lg">
                  Field Layout
                </label>
                <p className="fb-muted" style={{ fontSize: '0.85rem', marginBottom: '1rem' }}>
                  How fields in each row are arranged.
                </p>
                <div className="fb-radio-row">
                  <label className="fb-radio-label">
                    <input
                      type="radio"
                      name="fieldDirection"
                      checked={designSettings.fieldDirection === 'horizontal'}
                      onChange={() => setDesignSettings(s => ({ ...s, fieldDirection: 'horizontal' }))}
                    />
                    <span>Horizontal</span>
                    <span className="fb-muted" style={{ fontSize: '0.8rem' }}>(fields across)</span>
                  </label>
                  <label className="fb-radio-label">
                    <input
                      type="radio"
                      name="fieldDirection"
                      checked={designSettings.fieldDirection === 'vertical'}
                      onChange={() => setDesignSettings(s => ({ ...s, fieldDirection: 'vertical' }))}
                    />
                    <span>Vertical</span>
                    <span className="fb-muted" style={{ fontSize: '0.8rem' }}>(fields stacked)</span>
                  </label>
                </div>
                <label className="fb-radio-label">
                  <input
                    type="checkbox"
                    checked={designSettings.showScroller}
                    onChange={(e) => setDesignSettings(s => ({ ...s, showScroller: e.target.checked }))}
                  />
                  <span>Show scrollbar when form is tall</span>
                </label>
                <div className="fb-muted" style={{ fontSize: '0.8rem', marginTop: '0.25rem', marginLeft: '1.5rem' }}>
                  When unchecked, the form expands to full size with no scrolling.
                </div>
              </div>
              
              <div className="fb-grid-theme">
                <div>
                  <label className="fb-label">
                    Primary Color
                  </label>
                  <div className="fb-color-row">
                    <input
                      type="color"
                      className="fb-color-swatch"
                      value={theme.primaryColor}
                      onChange={(e) => setTheme({ ...theme, primaryColor: e.target.value })}
                    />
                    <input
                      type="text"
                      className="fb-input"
                      value={theme.primaryColor}
                      onChange={(e) => setTheme({ ...theme, primaryColor: e.target.value })}
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>

                <div>
                  <label className="fb-label">
                    Background Color
                  </label>
                  <div className="fb-color-row">
                    <input
                      type="color"
                      className="fb-color-swatch"
                      value={theme.backgroundColor}
                      onChange={(e) => setTheme({ ...theme, backgroundColor: e.target.value })}
                    />
                    <input
                      type="text"
                      className="fb-input"
                      value={theme.backgroundColor}
                      onChange={(e) => setTheme({ ...theme, backgroundColor: e.target.value })}
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>

                <div>
                  <label className="fb-label">
                    Text Color
                  </label>
                  <div className="fb-color-row">
                    <input
                      type="color"
                      className="fb-color-swatch"
                      value={theme.textColor}
                      onChange={(e) => setTheme({ ...theme, textColor: e.target.value })}
                    />
                    <input
                      type="text"
                      className="fb-input"
                      value={theme.textColor}
                      onChange={(e) => setTheme({ ...theme, textColor: e.target.value })}
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>

                <div>
                  <label className="fb-label">
                    Border Color
                  </label>
                  <div className="fb-color-row">
                    <input
                      type="color"
                      className="fb-color-swatch"
                      value={theme.borderColor}
                      onChange={(e) => setTheme({ ...theme, borderColor: e.target.value })}
                    />
                    <input
                      type="text"
                      className="fb-input"
                      value={theme.borderColor}
                      onChange={(e) => setTheme({ ...theme, borderColor: e.target.value })}
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>

                <div>
                  <label className="fb-label">
                    Border Radius
                  </label>
                  <input
                    type="text"
                    className="fb-input"
                    value={theme.borderRadius}
                    onChange={(e) => setTheme({ ...theme, borderRadius: e.target.value })}
                    placeholder="8px"
                  />
                </div>

                <div>
                  <label className="fb-label">
                    Button Color
                  </label>
                  <div className="fb-color-row">
                    <input
                      type="color"
                      className="fb-color-swatch"
                      value={theme.buttonColor}
                      onChange={(e) => setTheme({ ...theme, buttonColor: e.target.value })}
                    />
                    <input
                      type="text"
                      className="fb-input"
                      value={theme.buttonColor}
                      onChange={(e) => setTheme({ ...theme, buttonColor: e.target.value })}
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>

                <div>
                  <label className="fb-label">
                    Button Text Color
                  </label>
                  <div className="fb-color-row">
                    <input
                      type="color"
                      className="fb-color-swatch"
                      value={theme.buttonTextColor}
                      onChange={(e) => setTheme({ ...theme, buttonTextColor: e.target.value })}
                    />
                    <input
                      type="text"
                      className="fb-input"
                      value={theme.buttonTextColor}
                      onChange={(e) => setTheme({ ...theme, buttonTextColor: e.target.value })}
                      style={{ flex: 1 }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Live Preview */}
            <div className={`fb-card fb-card-fit${isMobile ? ' is-mobile' : ''}${!isMobile ? ' fb-card-sticky' : ''}`}>
              <h3 className="fb-subsection-title">Live Preview</h3>
              <p className="fb-muted" style={{ marginBottom: '1.5rem', fontSize: '0.9rem' }}>
                See how your form will look with the current theme and layout settings.
              </p>
              
              <div
                className="fb-preview-frame"
                style={{
                  border: `2px solid ${theme.borderColor}`,
                  borderRadius: theme.borderRadius,
                  background: theme.backgroundColor,
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: '1.5rem', color: theme.textColor }}>
                  {formName || 'Contact Form'}
                </h3>
                
                {fields.length === 0 ? (
                  <p style={{ color: theme.textColor, textAlign: 'center', padding: '2rem' }}>
                    Add fields to see preview with selected layout.
                  </p>
                ) : (
                  <FormRenderer
                    fields={fields}
                    rows={rows}
                    theme={theme}
                    layout={layout}
                    layoutConfig={layoutConfig}
                    fieldDirection={designSettings.fieldDirection}
                    formName={formName}
                    formData={previewData}
                    onFieldChange={(name, value) => {
                      setPreviewData({ ...previewData, [name]: value });
                    }}
                    onSubmit={(e) => {
                      e.preventDefault();
                      showToast('Preview mode, form not submitted', 'info');
                    }}
                    readOnly={false}
                  />
                )}
              </div>
            </div>
          </div>
  );
}
